import { requestApi } from '../util/network'
// 获取手机验证码
export const getSmsCaptcha =
    (type, phone) =>
      requestApi(
        '/Connect/get_sms_captcha',
        'GET',
        {
          'type': type,
          'phone': phone
        }
      )
// 获取email验证码
export const getEmailCode =
    (type, email) =>
      requestApi(
        '/Connect/get_email_verify_code',
        'GET',
        {
          'type': type,
          'email': email
        }
      )
// 檢查email验证码
export const checkEmailCode =
    (memberId, type, email, code) =>
      requestApi(
        '/Connect/check_email_verify_code',
        'GET',
        {
          'member_id': memberId,
          'type': type,
          'email': email,
          'verify_code': code,
        }
      )
export const checkSmsCaptcha =
    (type, phone, captcha) =>
      requestApi(
        '/Connect/check_sms_captcha',
        'GET',
        {
          'type': type,
          'phone': phone,
          'captcha': captcha
        }
      )
// 验证手机验证码
export const checkVerifyCode =
    (type, userType, verifyCode) =>
      requestApi(
        '/Index/check_verify_code',
        'GET',
        {
          'type': type,
          'user_type': userType,
          'verify_code': verifyCode
        }
      )
export const getWechatShare =
    (url) =>
        requestApi(
            '/index/getWechatShare',
            'POST',
            {
                'url': url
            }
        )
export const sendVerifyCode =
    (send_type, verify_code_type, user_type, user_name) =>
      requestApi(
        '/Index/send_verify_code',
        'POST',
        {
          send_type: send_type,
          user_type: user_type,
          verify_code_type: verify_code_type,
          user_name: user_name

        }
      )
// 验证码检测
export const checkPictureCaptcha =
    (captcha) =>
      requestApi(
        '/Seccode/check',
        'POST',
        {
          'captcha': captcha
        }
      )
